import Framebus from "framebus";

export const frameBus = new Framebus()

export default frameBus
